import { Box, styled } from '@mui/material';

export const ContentWithSidebar = styled('main')(() => ({
  display: 'flex',
}));

export const ContentWithTopBar = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobileView',
})<{ isMobileView: boolean }>(({ isMobileView }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  padding: `0px 48px 48px`,

  ...(isMobileView && {
    padding: `0px 12px`,
  }),
}));

export const Content = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
